<!-- @format -->
<div
	id="product-reviews-highlight-container"
	[attr.data-bv-product-id]="productIdentifier"
	[attr.data-bv-show]="isHydrated() ? 'reviews' : null"
	data-bv-seo="false"
	data-bv-ready="true"
	class="reviews-highlight-container hmf-display-flex hmf-flex-column hmf-mx-0"
	[ngClass]="{
		'hmf-mb-xl hmf-pb-0 hmf-pb-md-m': reviewsMVPRetest(),
		'hmf-mb-s hmf-pt-0': !reviewsMVPRetest()
	}">
	@if (reviewsHighlightsUpdateEnabled()) {
		@if (reviewSummary?.reviewCount) {
			<p
				class="hmf-pl-m-s hmf-display-s hmf-text-align-center hmf-text-align-m-left hmf-m-0 hmf-w-100">
				REVIEWS
			</p>
			<product-reviews-responsive-rating-summary
				class="hmf-mt-l"
				[percentage]="reviewSummary.recommendationPercentage ?? 0"
				[rating]="(ratingValue() ?? reviewSummary.averageRating) ?? 0"
				[overallRatingRange]="reviewSummary.overallRatingRange ?? 0"
				[count]="ratingCount() ?? reviewSummary.reviewCount"
				[productName]="productName"
				[isDrawer]="false"
				[includeSEO]="true">
			</product-reviews-responsive-rating-summary>
		}
	} @else {
		<product-reviews-summary class="hmf-mt-l"></product-reviews-summary>
		<product-reviews-secondary-rating [isHighlight]="true"></product-reviews-secondary-rating>
		<product-reviews-review-button
			class="hmf-mt-m hmf-mt-m-l hmf-align-self-center"
			[label]="writeAReviewLabel"
			[type]="writeAReviewType"></product-reviews-review-button>
	}

	@if (isReviewsAISummaryEnabled()) {
		<product-reviews-ai-summary></product-reviews-ai-summary>
	}

	@if (isReviewImgPlacementEnabled()) {
		<div class="hmf-px-s">
			<product-reviews-carousel-component
				[listenOpeningModal]="true"
				[mediaSource]="mediaSource"
				[productIdentifier]="productIdentifier">
			</product-reviews-carousel-component>
		</div>
	}

	@if (!reviewsMVPRetest()) {
		<product-reviews-carousel-component
			class="carousel-container"></product-reviews-carousel-component>
	}
	@if (isHighlyRatedReviewsEnabled()) {
		<product-reviews-ai-pros-cons></product-reviews-ai-pros-cons>
	}
	<product-reviews-review-latest-carousel></product-reviews-review-latest-carousel>
	<product-reviews-content-list
		[isUtagBazaarvoiceEnabled]="isUtagBazaarvoiceEnabled()"
		[ratingCount]="ratingCount()"
		[ratingValue]="ratingValue()"
	></product-reviews-content-list>
	@if (reviewsHighlightsUpdateEnabled() && reviewSummary?.reviewCount) {
		<product-reviews-review-button
			class="hmf-mt-m hmf-mt-m-l hmf-align-self-center"
			[minWidth]="200"
			[label]="writeAReviewLabel"
			[type]="writeAReviewType"></product-reviews-review-button>
	}
</div>
